import React from 'react';
import AppIcon, { APP_ICON_NAMES } from './AppIcon';
import { partial } from '../../util/translation/translation';

const p = partial('appLayout');

/**
 * Choose an icon for a More menu row from the app's own icon set, or keep
 * the app's default (''). Works as a redux-form field (input) or on its own
 * (value, onChange). Each icon wraps a real radio input, like ChoiceCards.
 * Styles: .icon-picker in containers/app_layout.scss.
 */
const IconPicker = ({ input, value, onChange, ariaLabel }) => {
  const current = (input ? input.value : value) || '';
  const pick = input ? input.onChange : onChange;
  const name = input?.name || 'more-icon';

  return (
    <div className="icon-picker" role="radiogroup" aria-label={ariaLabel}>
      {['', ...APP_ICON_NAMES].map((icon) => {
        const checked = current === icon;
        return (
          <label
            key={icon || 'default'}
            className={`icon-picker__option${
              icon ? '' : ' icon-picker__option--default'
            }${checked ? ' icon-picker__option--on' : ''}`}
            title={icon || p('iconDefault')}
          >
            <input
              type="radio"
              name={name}
              value={icon}
              checked={checked}
              onChange={() => pick(icon)}
            />
            {icon ? <AppIcon name={icon} /> : p('iconDefault')}
          </label>
        );
      })}
    </div>
  );
};

export default IconPicker;
